export const SNACKBAR_TIMER_INFO = 3;
export const SNACKBAR_TIMER_DELETE = 10;
export const SNACKBAR_TIMER_UPGRADE = 5;
export const SNACKBAR_TIMER_REFRESH = 60;
export const SNACKBAR_TIMER_ERROR = 10;
